module.exports = __webpack_public_path__ + "static/media/IMG-3.0d14ed90.jpg";